
import "../../assets/css/views/notification.scss";
import NoData from "../NoData";
import RackHealthNotification from "./RackHealthNotification";

export default function Notification(props: any) {
    return <div className="notification header-notification">
        <h2>Notifications</h2>
        <div className="scroll_not">
            {
                props?.NotificationData?.length === 0 ? <NoData sub_title="There are no notifications to display."></NoData> :
                props?.NotificationData?.map((data: any) => {
                    return <RackHealthNotification  data={data} />
                })
            }
        </div>
        {
            props?.NotificationData?.length === 0 ? " " : 
            <div className="btn-all-notification">
                <a href="/notifications" className="link_btn">View All Notifications</a>
            </div>
        }
    </div> 
}
